import { Modal } from '@ace/core';

import React from 'react';
import { useTheme } from '@mui/material/styles';
import { RegisterForm } from './components/RegisterForm';
import { useStyles } from './Register.styles';
import { ThemeProps } from '@styles/theme';
export type RegisterModalProps = {
    isOpen: boolean,
    onRequestClose: () => void,
}
export const Register: React.FC<RegisterModalProps> = ({ isOpen, onRequestClose }) => {
    const theme = useTheme<ThemeProps>();

    const styles = useStyles({ theme });

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={styles.modal}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
        >
            <RegisterForm />
        </Modal>
    )
};